import { render, staticRenderFns } from "./PreviewModal.vue?vue&type=template&id=48f0de1c&scoped=true&"
import script from "./PreviewModal.vue?vue&type=script&lang=js&"
export * from "./PreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewModal.vue?vue&type=style&index=0&id=48f0de1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f0de1c",
  null
  
)

export default component.exports